import React from 'react';
import { PropTypes } from 'prop-types';

import cx from 'classnames';
import s from './ClearFormButton.css';

const ClearFormButton = ({hasDraft, isLoading, onClick, onMouseDown}) => {
    return (
        <div className={s.component}>
            <nav className={s.container}>
                <button
                    type="button"
                    className={cx(s.iconButton)}
                    disabled={!hasDraft || isLoading}
                    onMouseDown={onMouseDown}
                    onClick={onClick}
                    onMouseUp={e => {e.preventDefault()}}
                >
                CLEAR FORM
                </button>
            </nav>
        </div>
    );
};

ClearFormButton.propTypes = {
    hasDraft: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
    onMouseDown: PropTypes.func,
};

export default ClearFormButton;


// WEBPACK FOOTER //
// ./src/components/Pages/Forms/PrivateForms/FormButtons/ClearFormButton/ClearFormButton.js